import { orderBy } from 'lodash-es';
import { MapActivity, MapMilestone } from '@/store';

export function calculateFinalMilestoneMinDeadlinePosition(
  phaseStart: number,
  activities: MapActivity[],
  milestone: MapMilestone,
) {
  let previousActivityPosition = 0;
  if (activities.length) {
    const lastActivity = orderBy(activities, ['originalPosition'], 'desc')[0];
    previousActivityPosition = lastActivity.originalPosition;
  }

  return Math.max(
    phaseStart + 1,
    previousActivityPosition,
    milestone.previousMsPosition + 1,
  );
}
